import { useNavigate } from "react-router-dom";

export function ClickableComponent({
  image,
  outside,
  title,
  description,
  icon,
  iconBg,
  link,
}: {
  image: string;
  outside: boolean;
  title: string;
  description: string;
  icon: React.ReactNode;
  iconBg: string;
  link: string;
}) {
  const navigate = useNavigate();
  const colorVariants = {
    blue: "from-blue-500 to-blue-600",
    red: "from-red-500 to-red-600",
    green: "from-green-500 to-green-600",
    indigo: "from-indigo-500 to-indigo-600",
    violet: "from-violet-500 to-violet-600",
    orange: "from-amber-300 to-amber-500",
    cyan: "from-cyan-500 to-cyan-600",
  };
  return (
    <div
      className={`bg-gradient-to-b from-blue-100 via-blue-200 to-blue-200 dark:from-blue-950/30 dark:via-blue-950/40 dark:to-blue-950/50 relative my-2 rounded-xl transition-colors duration-200 ${
        outside ? "" : "overflow-hidden"
      }`}
    >
      <img
        src={image}
        className={`absolute ${outside ? "-top-4" : "-top-2"} left-0`}
      />
      <div className="h-52 relative">
        <div
          className={`absolute w-12 h-12 top-48 left-5 bg-gradient-to-b ${
            colorVariants[iconBg as keyof typeof colorVariants]
          } rounded-lg border-white dark:border-gray-900 border flex items-center justify-center`}
        >
          {icon}
        </div>
      </div>
      <div className="bg-blue-50 dark:bg-gray-950 p-4 rounded-b-xl space-y-1.5 border-3 border-t-0 border-blue-100 dark:border-blue-950/50 transition-colors duration-200">
        <h1 className="text-xl font-bold mt-7 text-gray-900 dark:text-white">
          {title}
        </h1>
        <p className="text-md leading-5.5 text-gray-500 dark:text-gray-400 mb-7">
          {description}
        </p>
        <button
          className="rounded-lg bg-gradient-to-b from-purple-600 to-purple-400 dark:from-purple-500 dark:to-purple-700 px-4 py-2.5 font-bold text-white border border-black dark:border-gray-900 border-b-2 cursor-pointer hover:opacity-90 transition-opacity duration-200"
          onClick={() => {
            navigate(link);
          }}
        >
          Generate Now
        </button>
      </div>
    </div>
  );
}
